module.exports = __webpack_public_path__ + "img/featured01.74b4088d.jpg";